import get from 'lodash/get'

import { SegmentProductInfo } from 'components/FieldRenderers/Renderers/segmentProduct'
import { CURRENCIES } from 'configuration/currency'
import { UNDEFINED_VALUE } from 'const/formatting'

import {
    formatDecimal,
    parseCurrency,
    parsePercentageInput,
} from './inputNumber'
import { isUnset } from './utilities'

export const getMetricValueFormatter =
    (metricType: string, currencyCode = 'USD') =>
    (value?: string | number): string => {
        if (isUnset(value)) {
            return ''
        }

        if (metricType === 'currencyAmount') {
            return `${get(
                CURRENCIES,
                [currencyCode, 'symbol'],
                ''
            )} ${formatDecimal(value)}`
        }

        if (metricType === 'percentage' || metricType === 'percentage_as_is') {
            return `${value}%`
        }

        return formatDecimal(value)
    }

export const getMetricValueParser =
    (metricType: string) =>
    (value: string): string => {
        if (metricType === 'currencyAmount') {
            return parseCurrency(value)
        }

        if (metricType === 'percentage' || metricType === 'percentage_as_is') {
            return parsePercentageInput(value)
        }

        return value
    }

export const formatSegmentProductName = (
    record: SegmentProductInfo,
    metadataPath: string | undefined,
    options?: {
        includeAsin?: boolean
        maxTitleLength?: number
    }
): string => {
    const metadata = metadataPath ? get(record, metadataPath) : {}

    if (isUnset(metadata)) {
        const childrenCount =
            get(record, 'variant_count__total') ??
            get(record, 'variant_count__max') ??
            0
        const productId = get(record, 'product_id')
        const asin = productId?.split('_')[1]
        if (childrenCount > 0) {
            return `Parent ASIN (${childrenCount} variant${
                childrenCount > 1 ? 's' : ''
            }): ${asin}`
        }

        return UNDEFINED_VALUE
    }

    let title =
        metadata.hero_asin_title ??
        record.hero_asin_title ??
        metadata.title ??
        record.title ??
        UNDEFINED_VALUE

    if (options?.maxTitleLength) {
        title =
            title.length > options.maxTitleLength
                ? `${title.slice(0, options.maxTitleLength)}…`
                : title
    }

    const asin = metadata.asin ?? record.asin
    const asinDisplay = asin ? ` (${asin})` : ''

    return `${title}${options?.includeAsin ? asinDisplay : ''}`
}
